export type WeatherConditionUI = {
	cond: string;
	op: string;
	value: string;
	locid: string | number;
	hours: number;
	execution_type: 'any' | 'once';
	thsval?: string; //needed this for invalid weather labels
};

export function is_weather_cond_ui(o: any): o is WeatherConditionUI {
	return (
		typeof o === 'object' &&
		typeof o.cond === 'string' &&
		typeof o.op === 'string' &&
		typeof o.value === 'string' &&
		['string', 'number'].includes(typeof o.locid) &&
		typeof o.hours === 'number'
	);
}
